import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, DELETE } from "../../../../_shared/constants";
import { DELETE_PROJECT } from "../../../actions";

export const deleteProject: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === DELETE_PROJECT.START) {
      const { payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: DELETE,
          url: `${APP_URL.project.delete}`,
          onFinish,
          payload,
          onSuccess: DELETE_PROJECT.SUCCESS,
          ...rest,
        })
      );
    }
  };
